// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mid-grey {\n    color: #8F9FA1;\n}\n", "",{"version":3,"sources":["webpack://./drund/media/drundpress/themes/buckeye_report/css/general/colors.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB","sourcesContent":[".mid-grey {\n    color: #8F9FA1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
